var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0103a",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fedf00",
    d: "M.7 0h36.2v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0018a8",
    d: "M.7 0h17v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7b37f",
    d: "M25.7 11.4c.6 0 1 .5 1.5.5q.6 0 1-.3l.7-.2q.4 0 .6.3l.1.6-.2.7-.1.3q.1.6.8.5s.6 0 1-.4q-.4 0-.5-.3t.4-.4h.1l.1-.1.3-.2h.2l.1.1h.5v.2l.4-.1q.3 0 .4.2v.1l.5.3.2.1.2.4v.2c-.2.6-.5.7-1 1.2l-.2.6.1.3q0-.3.2-.3l.3.3v.1h.5q.4 0 .7.2a2 2 0 0 1 .6 1.4c0 .5 0 1.3-1.1 1.6q.3 0 .3.4l-.3.4-.3-.1q-.3.3-.3.8l.1.5.3.4.4-.2q.2 0 .3.2v.1l.1.1v.2l.2.1v.3q0 .4-.5.4h-.2l.4.4q.3.3.2.8t-.2 1l-.6.7-1.3.5-1 .1h-1.1q-.9 0-1.4.6.3.2.3.6t-.4.5h-.2v.1l-.4.1-.5-.2-.5.4-.2.1-.2-.1-.4-.4-.5.2h-.4V28h-.3q-.4-.2-.4-.6t.4-.5q-.6-.6-1.4-.5h-1.2l-1-.2-.6-.2q-1.3-.6-1.5-1.9V24q0-.6.5-1l-.2-.1q-.4-.1-.4-.5v-.2l.2-.1v-.3q.2-.3.4-.3t.3.2q.2 0 .3-.3a1 1 0 0 0 .1-1.1V20l-.3.1q-.4 0-.4-.4l.2-.4-.4-.2-.4-.5-.2-.4v-.7q0-.5.3-1l.5-.4.5-.1h.5q0-.3.3-.4l.2.3v-.2q0-.4-.2-.7-.8-.6-1-1.3 0-.3.3-.4h.2V13l.2-.1.2-.1.1-.1q.1-.2.4-.2h.4l.2-.1h.8l.2.1q.5.3.5.5l-.2.3h-.2q.4.4 1 .4t.7-.5l-.1-.4-.2-.7.2-.6q.1-.2.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m23.4 13.3.2.1h.3V13l-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M34 19.7q-.1-.4-.3 0 0 .4.4.3l.2-.1v-.3l-.1-.3h-.3q-.7.1-1 1v1q0 .6.5 1l.8.5h.3q.5 0 .3-.6-.3-.4-.6 0v.3q.4 0 .3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m32.7 22.8.5-.3q.4 0 .7.2a2 2 0 0 1 .9 1.4l-.2.8q.2.3-1.3 1.2c-.5.2-1.5.3-2.1.3q-1.4-.1-2.1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M32.9 23.8v-.3h.5l.2.1.1.2.1.2q.2 1-.5 1.4l-1.2.4h-2.6l-.4.2h-.3l-.8.4-.2.1-.1.1q-.3.2-.4.6v.1q0 .4.4.4m.5-14.1v.3q0 .2-.2.2-.6-.2-.4-.6c.3-.5.8-.2 1.3 0l-.1-.3.4-.8v-.5h-.5c-.3 0-.7.4-1.4.4q-1-.2-1.4-.5h-.4q-.2.3 0 .6t.3.8v.3c.4-.2 1-.5 1.2 0q.2.4-.4.6l-.3-.2v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m26.9 13.3.2.4q0 .3-.2.4m.2-.3-.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7b37f",
    d: "M23.7 12.8h.2v.5h-.1v.1h-.4v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M23.6 13.1q-.1-.2-.2 0l.1.3.3-.1v-.5q-.5-.3-.8.1 0 .6.5.9.7.4 1.2.3 1.1-.2 1.7-.6h.2v.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M21.3 23.4h-.1l-.2.2v.1l-.2.2v.3m1.5-.7v.2l-.1.2-.1.1-.1.1h-.1l-.2.1m5.6 3.2q0 .3-.4.4m7.4-4.8.5 1.1q0 .6-.2.8.1.5-1.2 1.2l-2.2.3q-1.3-.1-2 .6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M33 23.6q.1-.2.4-.1l.2.1m.5-.8h.5q.4 0 .3-.5l-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M20.7 16.7q-.3 0-.4.2l-.2.6m3.8-4.3q0 .2-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M33.8 16a1.6 1.6 0 0 1 1.5 1.6c0 1.4-.8 1.6-1.1 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M33.9 16q1 0 1.4 1.7c0 1-.7 1.4-1 1.5m-.8 1.5v-.3l.1-.2V20l.2-.2m.6-.2v.2l-.2.1H34m-1.2-4.3v-.3l.2-.2.1-.1.1-.2.2-.1.1-.2.1-.1.2-.2v-.1l.2-.2v-.4m-1 10.6h.2V24l.1-.2m-13.2-1h.3v-.1m.5-3v.1l-.1.1h-.2m.8-1.2v.2l-.1.1h-.1l-.1.1h-.2m1.3-3.2-.1.2H22v.1h-.2v.1h-.1m0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M21.9 18.7h-.2m12.5 3.8h0q.4.1.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M33.8 20h.6v-.5l-.2-.2m.5 2.9v-.3l-.1-.1m0 0-.3-.3m-.3.3-.1-.1q-.4-.4-.4-1t.3-.7m-4.7 7 .1-.1.2-.1.1-.1.2-.1h.2l.2-.1h.3M28 28l-.7.5-.6-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m26.9 27.7-.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M26.9 27.5v.2m-.2.4h-.1l-.2.1h-.1m-.5-14.7v-.2q0-.5-.3-.9m0 0V12h.4l1.4.5q-.9-.2-1.3-.5h-.5zm0 0 .3.9v.2m1.5-1.2c.7 0 1.3-.5 1.5-.5l.3.1q0-.1-.4 0l-1.4.5m6.7 9.4a1 1 0 0 1-.6-1q0-.7.3-.9M28 28q0 .3-.6.6l-.7-.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M26.2 13.6h.5v.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m25.2 14.1 1.1-.4M29 27.3v.1h.1q0 .3-.2.3l-.2-.2m-3.5-13.4q.7-.2 1.1-.5m8.2 9h-.3l-.2-.2q-.5-.2-.6-.7l-.2-.7q-.1-.7.4-1.2 0-.3.3-.3m-12-3.2.3.4q0 .5-.8.9l-.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m22 17.1.2.3-.2.3-.7.4q-.3 0-.5-.2l-.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m22 17.7.2.4-.3.6h-.2M32.5 17v.3m0-.3v.4m0-1.3v.5m0-.7v.8m-.2 6.8q0 .3-.4.5l-.4.3-.6.2h-2.1l-1 .1-.5.4-.5-.4h-.4l-.5-.1h-1.6l-1-.2q-.4 0-.6-.4m3.5 4.5h.2m2.5-.2h.3V28l.2-.1v-.2m4-11.5q0-.3-.3-.4m-11 3.9-.2.3m.3-3.8-.3.3h-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M21 16.9q.2 0 .2-.2l-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M21.5 23.9h.2v-.3l-.5-.1-.2.2v.1l-.2.2q-.2.8.4 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M29 27.3h0v.4q-.3 0-.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m33.1 12.9.5.6q0 .4-.3.8c-.2.2-.9.8-.9 1.3q0 .6.4.7t.4 0q.4-.4 0-.6c-.3 0-.4.4-.1.3m1.5 5.8-.3-.3-.3.3v.3m-1.3-5.8-.3.4q0 .5.8.9h.5m-13-1-.4.4a1.4 1.4 0 0 0 0 1.6h.2m5.3 7.8q.6.1 1 .7v.4l-.2.6-.6.2-.3-.2m-3.9-9.4q.4.2.4.6l-.4.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M21.6 19.7q.5.5.6 1.2t-.5 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M28.2 14.1v-.5l.1.3-.1.2m4.3 7.2v1.6m-.1-1.7V23m0-3.5v1.2m0-1.1v1m0-2.3v.7m0-.8v1m0-1.6v.2m0-.3v.4m-.1 5.4v.1l-.4.5-.5.3-.5.2h-2.6l-.5.1-.5.3-1-.4h-2l-1.1-.2q-.2 0-.5-.3l-.2-.3m-.2-.2-.2.6-.4.2-.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m22 23.2.1.3v.5m-1.7 1.5 1 .6q1 .3 2 .3 1.4-.1 2.1.6m1.5-.3.3.4m-.6 1-.3.2H26l-.4-.2m-.4-.2.4.2m2.3 0-.7.5-.6-.5m1.3 0 .6.2.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m29 28-.1.1-.1.1h-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m29.2 27.1.2.3v.5l-.5.2m0 0-.4-.2m5.3-5.7-.6-.9v-.2q0-.8.4-1.3l.1-.2m0-6.3q.2 0 .3.4t-.3.8c-.2.3-1 .8-.9 1.2l.1.3m-.3.3h.6m-1.8-3.6.2.3q0 .5-.5.8-.3.3-.7.3m.6-.6-.2-.2m-1.3.4-.1-.1q-.2-.1 0-.4l.2-.9q0-.7-.4-.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M29.6 12.2v.4l-.1.2-.1.2v.1l-.1.1v.1h0M32.4 24h0q.3.3.5.3.5-.1.4-.2l-.1-.4H33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M20.4 22.9h-.3q-.4-.1-.3-.6m1-2.7.1.1q0 .4-.4.4l-.2-.2-.1-.2m1.8-2 .1.2m0-.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m22.2 17.5-.2.2-.7.4-.5-.2-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m22 16.3.1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M22.2 17q-.1.4-.8.6H21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M20.7 16.9q0 .4.4.4c.4 0 .6-.6.3-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m19.8 18.8.2.2.5.3m.4 0q.6 0 .5-.6 0-.3-.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m21.5 15.7.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M21.5 13.6q0 .3.4.5m12 2.6q.2.4-.4.5l-.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M32.5 14v1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M21 16.9q.3 0 .2-.3 0-.1-.4 0c-.2.1-.2.6.3.6q.7-.1.3-1-.7-.4-1.4 0a2 2 0 0 0-.3 2.4v.2l.2.1q.4.4 1 .4t.5-.7q-.1-.4-.6-.3-.2.3 0 .5.3 0 .2-.2m10.8-6h.6v.7q0 .3-.2.4m.2-1q.4-.2.7.1l.1.5a1 1 0 0 1-.5.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M33.6 13.3q.4 0 .4.4t-.4.8c-.2.2-.9.7-.8 1.2q0 .3.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M33.6 16.9q-.2 0-.2-.2t.4-.1c.2.1.2.6-.3.6q-.7-.1-.3-1 .7-.4 1.4 0 .4.4.6 1 .1 1.1-.5 1.8-.4.3-1 .3t-.5-.7q0-.4.6-.3.3.3 0 .5-.3 0-.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M33.4 16.7q.1-.4.5-.4 1 .2 1 1.3 0 1.3-1 1.3-.3 0-.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "square",
    strokeWidth: 0.1,
    d: "M33.7 16.5q.9.4.8 1.2.2.8-.8 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M34.7 22.1a.3.3 0 1 0-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M33.5 21.6q.1.3.6.5m-.1.9q-.5-.4-1.3-.2l-.4.4.2.8.4.2q.4 0 .4-.3t-.2-.3H33v.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M29 27.4v.3q-.4 0-.4-.3a.4.4 0 0 1 .4-.4q.3 0 .4.3v.5l-.5.3q-.7-.1-.7-.7c0-.6 1-1 1.4-1L31 26h.8l.8-.1q.6-.2 1-.6.4-.2.5-.6a1 1 0 0 0-.1-1.2 1 1 0 0 0-.9-.6q-.4 0-.7.4v.5l.4.3q.4 0 .4-.3t-.2-.3h0v.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M28.8 26.4q-.6.1-1 .7v.4l.2.6.6.2.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M32.8 18.7q-.4 0-.4.6l.4.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M33 19.7q-.6.5-.6 1.2T33 22"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M31.2 12.7q.2-.4.6-.2t.2.8l-.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M22.8 12.6h-.6l-.1.7q0 .3.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m22.2 12.7-.7.1-.1.5q0 .6.5.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m21.5 12.9-.5.5q0 .6.3.8c.2.3.9.9.9 1.4q0 .6-.4.7h-.4q-.4-.4 0-.6c.3 0 .4.4.1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M21 13.3q-.3 0-.4.4 0 .4.4.8c.2.2.8.7.8 1.2q0 .3-.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M20.5 19.7q.3-.4.4 0-.1.4-.4.3l-.3-.1v-.5h.2l.3-.1q.6.1 1 1v1q0 .6-.5 1l-.8.5H20q-.4 0-.3-.6.1-.4.6 0v.3q-.3 0-.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M20.2 22.5h.3q.4-.2.7-.8l.2-.4V21q0-.7-.4-1.2 0-.3-.3-.3m-.8 2.6a.3.3 0 0 1 .6-.3.3.3 0 0 1 0 .5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m20 21.8.3-.3.3.3v.3m0-.3a1 1 0 0 0 .5-1q0-.7-.3-.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M21 21.6q-.1.3-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M21.9 22.8q-.1-.3-.5-.3t-.7.2a2 2 0 0 0-.9 1.4l.2.8q-.2.3 1.3 1.2l2.1.3q1.4-.1 2.1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M20.6 23q.5-.4 1.3-.2l.4.4-.2.8-.4.2q-.4 0-.4-.3t.2-.3h.2v.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M21.7 23.8v-.3h-.5l-.2.1-.1.2-.1.2q-.2 1 .5 1.4t1.2.4h2.6l.6.2 1 .4.1.1.1.1q.3.2.4.6v.1q0 .4-.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M25.6 27.4v.3q.4 0 .4-.3a.4.4 0 0 0-.4-.4l-.4.3v.5l.5.3q.6-.1.6-.7c0-.6-1-1-1.3-1l-1.5-.3h-.8l-.8-.1q-.6-.2-1-.6a1.4 1.4 0 0 1-.4-1.8 1 1 0 0 1 .9-.6q.4 0 .7.4v.5l-.4.3q-.4 0-.4-.3t.2-.3h.2v.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M23.4 12.7h0q-.2-.4-.6-.2-.2.3-.2.8l.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M31.2 13.3q-.4.6-1.1.5-.4 0-.7-.2l-.1-.4q.2-.3.3-1t-.5-.8c-.5-.2-1 .4-1.4.5H27c-.4-.1-1-.7-1.4-.5q-.5.1-.5.9l.3.9q.1.3-.1.4l-.7.2q-.7 0-1.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m25.4 26.2.5.2q.6.2 1 .7v.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M25.5 28h.2q.6 0 .7-.6l-.3-.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M25.5 27.4q0 .3.2.3t.3-.3l-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M33.2 12.9q.4 0 .5.6t-.4.7q0 .3-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m32.9 12.6.2.2.1.5q0 .5-.5.8m-.4-1.5h0a1 1 0 0 1 .1 1l-.2.1m-.4-1.2q.3.3.2.8 0 .3-.4.4m1 3.4v.2l.6.3h.5M20.1 22q.2 0 .3.2v.3q-.3.1-.4-.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M20.8 19.3q.7.2 1 1v1a2 2 0 0 1-.7 1.2H21m-.7-1q.3 0 .3.4v.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M20.2 21.7q.3 0 .4.4l-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M21.8 20q.3.2.3.6m0 .7-.4.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m21.9 18.7.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m22.2 18.3-.3.4m-.8-1.5h.3V17l.1-.1v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M20.8 16.6h-.3l-.2.3a1.4 1.4 0 0 0 0 1.6l.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M21.7 15.8q0 .3-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M21.1 16.5q-.2-.2-.8 0l-.1.2-.1.1-.2.4-.1.5v.3l.2.5q0 .3.7.4.3 0 .4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M31 13h.2q.1.2-.1.4l-.4-.1V13l.1-.2q.5-.3.8.1 0 .6-.5.9l-1.2.3q-1.1-.2-1.7-.6h-.3v.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M31.1 13h.2q0 .3-.2.4m1.5 4.3q-.3.6.2 1h.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "m32.6 17.1-.1.3v.3l.8.3.5-.1.4-.5m-1.8 5.2v.2l-.2.6q0 .3-.3.5l-.5.3-.5.2h-3.1l-.5.4-.5-.3-.5-.1h-2l-1.1-.2q-.3 0-.5-.3l-.4-.5-.1-.6v-8.7h10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7b37f",
    d: "M21.3 23.8a.2.2 0 1 1 .4 0 .2.2 0 0 1-.4 0M20 22.3l.2-.2.1.2-.1.2zm.8-3.7.1-.1.2.1-.2.2zm2.5-5.4.1-.2.2.1-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c7b37f",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M20.6 19.5q0 0 0 0l-.1.1v.1m.4 2.2h0l.1-.1v-.1l.1-.1m-.1 1.1-.1.1h-.1l-.1.1-.1.1m1.2-3.2h0-.1l-.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c7b37f",
    strokeWidth: 0.1,
    d: "m21.8 18.7-.2.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c7b37f",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M20.5 17.4q0 0 0 0v.2l.3.3h.1m0-.5h0l.3.1h.1m.6-3.4h-.1l-.2-.2q0 0 0 0l-.2-.2m.7-.4v.2l.1.1.3.2m0-.5.1.1.1.1.1.2h.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#703d29",
    d: "m28.4 12.6-.2-.1-.3.2-.6.1-.6-.1-.3-.2-.2.2.2-.1.4.2.5.1.6-.1.4-.2zm-5.7 11.8v-.1h-.1v.2l-.3.2v-.5h.1-.2v.7zm.3.1v-.1h-.2v.5l-.2.1h.2zm.3 0q.2 0 .1.3h-.1zm-.3.5h.2l.1.2.1.2h.1v-.1l-.1-.3.1-.1-.1-.3H23zm.7.2v.1h.2v-.5h.3l-.3-.1-.3-.1v.1h.2zm1-.3h.2zv.1l-.2.3v-.5h-.2v.7h.1zm.1.6.2.1q.2 0 .2-.2v-.2L25 25l.2.1V25l-.1-.1-.2.1v.3q.3 0 .3.2H25l-.1-.2zm1.4-.4H26v.2l-.1.2-.1-.3v-.1h-.1V25h-.1l.2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#703d29",
    d: "M26.3 25.7v.1h.1zv-.4l.4.5v-.5l.1-.1h-.2v.4l-.3-.4h-.2l.1.1zm.9-.4v-.1H27v.6h.2zm.3.4v.1h.2v-.6l.2.1v-.1h-.6v.1l.1-.1h.1zm.6-.2v-.2zm.1 0v.1l.1.1v.1h.2L28 25l-.2.6v.1h.2-.1v-.2zm.7-.4h.3zh-.2zv.6h.2v-.3h.1v-.1H29zm.3.3q0 .3.4.3.4-.2.3-.5 0-.3-.4-.3-.3.1-.3.5m.1-.1q0-.2.2-.3l.3.3q0 .2-.2.3t-.3-.3m.7-.3v-.1l.3.1-.2.2zm0 .4v.2h.2v-.2l-.1-.1h.2l.2.2v-.1l-.2-.2V25l-.2-.2h-.2v.2zm.8-.1h.2zl-.2-.4h.2v-.2l-.2.1h-.3v.2l.1-.1h.1zm.4-.6v-.1H31zl.1.6h.2zm.2.2q0 .3.4.2.3-.1.2-.5 0-.2-.4-.2-.3.1-.2.5m0-.1q0-.2.2-.3l.3.2-.1.4q-.3 0-.3-.3m.7-.5h.3l-.1.2h-.1zm0 .5h.3l-.1-.1v-.2l.2.1h.2l-.3-.2v-.2q0-.2-.2 0H32l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M22.7 14.6H27V19h-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.7 18v.4l-.1.2-.2.2H24q-.5-.1-.5-.5-.2-.5-.4-.4v.3l.2.1-.2.2q-.1.1-.4-.4l.3-.4q.4 0 .5.3.1.5.5.6.3-.1.3-.5h.3m.4-.1v.4l.1.2.2.2h.4q.4-.1.5-.5t.4-.4v.3l-.2.1.1.2q.1.1.4-.4l-.2-.4q-.5 0-.6.3-.1.5-.5.6-.3-.1-.3-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fedf00",
    d: "m25.3 16.2.5-.6.1-.2h-.1l.1-.1v-.1h-.1V15l.1-.1h.1q.3-.4.8 0 .3.4-.1.6h-.4l.1-.2q.3 0 .3-.2l-.2-.2q-.3 0-.3.2v.4l-.2.1-.6.7-2.3 2.5-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23.6 16.4.6 1.8.7-.1.6.1.7-1.8-1.3-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fedf00",
    d: "m25 15.3.9 1.2-.5 1.4H25zm-.3 0-.9 1.2.5 1.4h.4zm2.8-.7H32V19h-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M28.1 14.6h.7V19H28zm1.3 0h.6V19h-.6zm1.2 0h.7V19h-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fedf00",
    d: "m22.7 22.8.1.3.2.4.4.2q.6.3 1.2.2h1.9l.6.1v-4.5h-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "m23.2 23.6.2.1.3.1v-4.3h-.5zm2.4.2v-4.3h-.5v4.4zm1-4.3h-.5v4.3h.5zm-2 0v4.4h-.4v-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fedf00",
    d: "m31.9 22.8-.1.3q0 .2-.3.4t-.6.3l-1 .1h-1.4l-1 .1v-4.5H32v3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M28.6 19.8v.1h-.1v.1l-.1.1h-.1v.2l.2.1h.2l.1.1v.1l.1.2v.6h.2v-.2l-.1-.1.1-.1h.2v.6h.2V21h.8v.1h.2v.2h-.1v.1h-.2v.1h.2l.1-.1.2-.2V21h.1v.6h.1v-.1l.1-.2v-.8l.1-.2v-.1l-.2-.2h-1.3l-.3.1H29V20h.1v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fedf00",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M31 20.5h0-.7l-.1.1h0-.1q0 0 0 0v-.1H30q0 0 0 0t0 0l.2-.1h.7v-.2q0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd900",
    d: "M28.7 20h-.1v.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fedf00",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M29.3 20.7v.2q0 0 0 0v.2m.4-.4h0v.2m-.7-.1.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fedf00",
    strokeWidth: 0.1,
    d: "M30.5 21h.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fedf00",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m30.1 21 .4-.2m-.2 0h.2l.2.2h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd900",
    d: "M28.3 20.2h.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065bd",
    d: "M28.7 20.8h-.1v-.3h.1v.2m-.2-.9v-.2zh.1zm.2.6h.1q.2 0 .2-.2l.1-.2H29l-.1.2zm.3 1h.1zm1.7 0h.1l.1.1h-.2m-1.4 0 .2.1h-.2m-.5-1.5v-.4.1h.1v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "m28.6 21.8-.1.1v.1h-.1v.1h-.1v.2h.2v.1h.2l.1.1.1.2v.7h.2v-.2L29 23l.1-.2h.2v.6l.1.1h.1v-.7h.8v.1h.2v.2l-.1.1-.2.1.2.1.1-.2.2-.2.1-.1v.6h.1v-.1l.1-.3v-.8l.1-.1V22l-.2-.1H29l.1-.1h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fedf00",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M31 22.5h0-.8 0-.1q0 0 0 0h0-.1v-.1q0 0 0 0h.9v-.2q0 0 0 0t0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd900",
    d: "M28.7 22h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fedf00",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M29.3 22.7v.3m.4-.4v.3m-.7-.2.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fedf00",
    strokeWidth: 0.1,
    d: "m30.5 23 .2-.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fedf00",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m30.1 23 .4-.2m-.2-.1h.2l.2.2h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd900",
    d: "M28.3 22.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065bd",
    d: "M28.7 22.7h-.1v-.2h.1zm-.2-.8v-.3.1l.1.1m.2.5.1.1.2-.2.1-.2H29zm.3 1 .1-.1zv.1zm1.7.1h.2v.1h-.2m-.5-.1v.1h-.1zm-.9.1h.2v.1h-.2m-.5-1.6v-.3l.1.1v.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#703d29",
    strokeWidth: 0.1,
    d: "M22.7 14.6H27V19h-4.4zm4.8 0H32V19h-4.4zm-4.8 8.2.1.3.2.4.4.2q.6.3 1.2.2h1.9l.6.1v-4.5h-4.4zm9.2 0-.1.3-.2.4-.4.2-.3.1-1 .1h-1.8l-.6.1v-4.5H32v3.3Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/ad.7ac763de665a552d848ec483fd34066d.svg";
export { ForwardRef as ReactComponent };